<template>
  <div id="xhs">
    <el-menu :default-active="'4'" mode="horizontal" background-color="#31323a" text-color="#fff"
             active-text-color="#409EFF" router="true">
      <el-menu-item style="width: 25%; text-align:center;" index="1" :route="{ path: '/xhs_zhaomu' }">
        小红书
      </el-menu-item>
      <el-menu-item style="width: 25%; text-align:center;" index="2" :route="{ path: '/dy_zhaomu' }">
        抖音
      </el-menu-item>
      <el-menu-item style="width: 25%; text-align:center;" index="3" :route="{ path: '/dp_zhaomu' }">
        大众点评
      </el-menu-item>
      <el-menu-item style="width: 25%; text-align:center;" index="4" :route="{ path: '/dw_zhaomu' }">
        得物
      </el-menu-item>
      <el-menu-item style="width: 25%; text-align:center;" index="5" :route="{ path: '/wb_zhaomu' }">
        微博
      </el-menu-item>
    </el-menu>
    <div class="line"></div>
    <router-view/>

    <div class="header" style="background-color: #31323a; height: 50px; line-height: 50px; margin-bottom: 10px;">
      <div class="h_headline" style="text-align:center; color:#FFFFFF; line-height: 1.4;">
        <img src="https://cdn.poizon.com/node-common/JUU1JUE0JTlBJUU5JTg3JThEJUU5JTg5JUI0JUU1JTg4JUFCaWNvbkAzeDE1ODYzMjU0MjM2NTQ=.png"
             style="float: left; width: 30px; height: 30px; margin: 10px;">
        <div style="float: left; font-size: 24px; font-weight: 700; height: 50px; line-height: 50px;">得物APP-达人报名</div>
      </div>
    </div>

    <el-form ref="form" :model="form" label-width="80px">
      <el-form-item label="得物链接">
        <el-input v-model="form.xhs_url" placeholder="请填写得物个人主页链接"></el-input>
      </el-form-item>
      <el-form-item label="微信号">
        <el-input v-model="form.xhs_wechat" placeholder="请填写微信号"></el-input>
      </el-form-item>
      <el-form-item label="手机号">
        <el-input v-model="form.xhs_phone" placeholder="请填写手机号"></el-input>
      </el-form-item>
      <el-form-item label="所属领域">
        <el-select v-model="form.xhs_category">
          <el-option label="美妆个护" value="美妆个护"></el-option>
          <el-option label="母婴亲子" value="母婴亲子"></el-option>
          <el-option label="服饰穿搭" value="服饰穿搭"></el-option>
          <el-option label="家居家装" value="家居家装"></el-option>
          <el-option label="探店出行" value="探店出行"></el-option>
          <el-option label="运动健身" value="运动健身"></el-option>
          <el-option label="健康养生" value="健康养生"></el-option>
          <el-option label="美食分享" value="美食分享"></el-option>
          <el-option label="宠物日常" value="宠物日常"></el-option>
          <el-option label="教育培训" value="教育培训"></el-option>
          <el-option label="商业财经" value="商业财经"></el-option>
          <el-option label="兴趣爱好" value="兴趣爱好"></el-option>
          <el-option label="科技数码" value="科技数码"></el-option>
          <el-option label="生活记录" value="生活记录"></el-option>
          <el-option label="搞笑娱乐" value="搞笑娱乐"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="图文报价">
        <el-input v-model="form.xhs_image_price" placeholder="请填写图文报价(不走引力平台，单位元)"></el-input>
      </el-form-item>
      <el-form-item label="视频报价">
        <el-input v-model="form.xhs_video_price" placeholder="请填写视频报价(不走引力平台，单位元)"></el-input>
      </el-form-item>
      <el-button type="primary" @click="onSubmit" style="width: 100%; background-color: #31323a;">立即提交</el-button>
    </el-form>

    <div id="m_input" style="position: relative; text-align: center; font-size: 16px; height: auto; margin-top: 20px;"> 提交后，请加PR微信:
      <span style="color: #ff0000; font-size: 20px; font-weight: bold;">maozhou2023</span>
    </div>

    <div style="margin-top: 10px">
      <el-image src="/static/maoapp/images/maoyan_pr_wx_2.jpg"></el-image>
    </div>

    <el-dialog title="操作提示"  width="80%" :visible.sync="dialogVisible" :center="true" :show-close="false">
      <span>{{dialogMsg}}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">知道了</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import process from "shelljs";

  export default {
    name: 'xhs',
    data() {
      return {
        form: {
          xhs_url: '',
          xhs_wechat:'',
          xhs_phone:'',
          xhs_category: '',
          xhs_image_price: '',
          xhs_video_price: ''
        },
        dialogMsg: '',
        dialogVisible: false,
      }
    },
    methods: {
      handleSelect(key, keyPath) {
        console.log(key, keyPath);
      },
      onSubmit() {
        let base = '/api'
        if (process.env.NODE_ENV === "development") {
          base = 'http://api.wushangxianzhi.com'
        }
        let url = '/api/v2/maoapp/zhaomu_vue_dw'
        this.$axios({
          method:'post',
          headers: {
            'content-type': 'application/x-www-form-urlencoded', // 注释1
          },
          url: `${base}${url}`,
          data:this.form,
        }).then((response) =>{          //这里使用了ES6的语法
          // alert(response.data.msg)
          this.dialogMsg = response.data.msg
          this.dialogVisible = true
          console.log(response.data)      //请求成功返回的数据
        }).catch((error) => {
          alert(error)
          console.log(error)      //请求失败返回的数据
        })
      }
    },
    metaInfo: {
      title: "袤-达人招募",
      meta: [
        { name: "viewport", content: "width=device-width, user-scalable=no, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0" },
        { name: "keywords", content: "袤周-大数据驱动下的智慧种草平台" },
        { name: "description", content: "袤周-大数据驱动下的智慧种草平台" },
        { name: "format-detection", content: "telephone=no,email=no" }
      ],
      link: [{
        rel: 'shortcut icon',
        href: '/static/favicon.ico'
      }]
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/zhaomu/Dewu.vue